import {useHistory, useLocation} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import {StrictTabProps} from 'semantic-ui-react';

import {ProjectData} from '../../state/graphql/projectPageQuery';

// Define tab names for URL paths
export const TAB_NAMES = ['details', 'users', 'providers'];
export const TAB_TITLES = ['Details', 'Project Roles', 'AI Providers'];

export const useProjectOverviewTabs = (
  showUsersTab: boolean,
  showProvidersTab: boolean,
  project: ProjectData
) => {
  const location = useLocation();
  const history = useHistory();

  // This a temporary structure to match indices to tab names
  const tabs = [TAB_NAMES[0]];
  if (showUsersTab) {
    tabs.push(TAB_NAMES[1]);
  }
  if (showProvidersTab) {
    tabs.push(TAB_NAMES[2]);
  }

  // Extract tab name from URL path
  const pathParts = location.pathname.split('/');
  // Find the index of the tab that matches the last part of the path
  const tabIndex = tabs.findIndex(
    tabName => pathParts[pathParts.length - 1] === tabName
  );
  // If the last part of the path is not a tab name, default to the details tab
  const activeTabIndex = tabIndex > -1 ? tabIndex : 0;

  // Handle tab change
  const handleTabChange: StrictTabProps['onTabChange'] = (_, {activeIndex}) => {
    if (typeof activeIndex === 'number') {
      const path = `/${project.entityName}/${project.name}/overview/${tabs[activeIndex]}`;
      history.push(path);
    }
  };

  return {activeTabIndex, handleTabChange};
};
